'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _LinkAccount = require('../../helpers/LinkAccount');

var _Logs = require('../../helpers/Logs');

var _Preauthorize = require('../../helpers/Preauthorize');

var _Product = require('../../helpers/Product');

var _Provider = require('../../helpers/Provider');

var _Router = require('../../helpers/Router');

var _SessionStorage = require('../../helpers/SessionStorage');

var _SSO = require('../../helpers/SSO');

var _LinkAccount2 = require('./LinkAccount.scss');

var _LinkAccount3 = _interopRequireDefault(_LinkAccount2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkAccount = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LinkAccount, _Component);

  function LinkAccount() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LinkAccount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LinkAccount.__proto__ || (0, _getPrototypeOf2.default)(LinkAccount)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      provider: null
    }, _this.login = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.LoginOptions));
    }, _this.signUp = function () {
      _this.props.pushState((0, _Router.getPath)(_Router.RouterConst.Welcome + '/' + _Router.RouterConst.SignUpOptions));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LinkAccount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var query = this.props.location.query;
      if ((0, _Preauthorize.isPreauthorize)(query) || _SSO.SSO.isSSO(query)) {
        (0, _Provider.getProviderRequest)(query.operator_id, this.props.auth, _SessionStorage.SessionStorageKeys.LinkAccountProviderKey, function (result) {
          _this2.setState({ provider: result });
        });
      } else {
        (0, _LinkAccount.setProviderInStorageForLinkAccount)(this.props.auth, function (result) {
          _this2.setState({ provider: result });
        });
        (0, _LinkAccount.setOldSessionIdInStorage)(this.props.auth.realm);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var formatMessage = this.props.intl.formatMessage;


      return _react2.default.createElement(
        'div',
        { className: _LinkAccount3.default.linkAccountContainer },
        _react2.default.createElement(
          'div',
          { className: _LinkAccount3.default.linkAccountContent },
          _react2.default.createElement(
            'div',
            { className: _LinkAccount3.default.title },
            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.UniversalLoginTitle, {
              values: { product: formatMessage((0, _Product.getProductName)(this.props.auth.realm, this.props.auth.productName, this.props.auth.clientId)) }
            }))
          ),
          _react2.default.createElement(
            'div',
            { className: _LinkAccount3.default.content },
            _react2.default.createElement(
              'div',
              { className: _LinkAccount3.default.subTitle },
              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.LinkAccountSubTitlePart1),
              _react2.default.createElement(_components.ProviderLogo, { className: _LinkAccount3.default.providerLogo, provider: this.state.provider }),
              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.LinkAccountSubTitlePart2)
            ),
            _react2.default.createElement(
              'div',
              { className: _LinkAccount3.default.freeText },
              _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.LinkAccountFree)
            )
          ),
          _react2.default.createElement(_components.BaseButton, { className: _LinkAccount3.default.button, onClick: this.signUp, buttonString: _DefaultString.translations.SignUp }),
          _react2.default.createElement(
            'div',
            { className: _LinkAccount3.default.already },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.AlreadyAccount)
          ),
          _react2.default.createElement(_components.BaseButton, { className: _LinkAccount3.default.button, onClick: this.login, buttonString: _DefaultString.translations.Login }),
          _react2.default.createElement(_components.HintPopup, { className: _LinkAccount3.default.whyStingray, text: _DefaultString.translations.LinkAccountWhyText, hintText: _DefaultString.translations.LinkAccountWhyExplanation, navigationLog: _Logs.LogName.WhyStingrayAccount })
        ),
        _react2.default.createElement(
          'div',
          { className: _LinkAccount3.default.free },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.StingrayMusicFreeExplanation)
        )
      );
    }
  }]);
  return LinkAccount;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  intl: _reactIntl.intlShape.isRequired,
  location: _react2.default.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(LinkAccount);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LinkAccount/LinkAccount.js
// module id = 2008
// module chunks = 0